@if ({ mobile: mobileLayout$ | async, editing: isEditing$ | async }; as layout) {
  @let showAssociationModal = showAssociationModal$ | async;
  <mat-card [class.editing]="layout.editing">
    <mat-card-content [class.editing]="layout.editing" class="card-content">
      @if (!enableNewActivityFeed()) {
        <ng-container [ngTemplateOutlet]="avatar"></ng-container>
      }
      @switch (activityTypeSelected) {
        <!-- Note -->
        @case ('Note') {
          <crm-activity-logger-note
            class="activity-content"
            [activity]="activity$ | async"
            [mobile]="layout.mobile"
            [(description)]="sharedDescription"
          >
            <ng-container *ngTemplateOutlet="activitySelector" crmLoggerContent="after-description"></ng-container>
            <ng-container crmLoggerContent="fields">
              @if (showAssociationModal === false) {
                <ng-container *ngTemplateOutlet="associationFormRow"></ng-container>
              }
              @if (showAssociationModal) {
                <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
                  <ng-container *ngTemplateOutlet="associationFormModal"></ng-container>
                </glxy-form-row>
              }
              <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
                <ng-container [ngTemplateOutlet]="addTeamMembers"></ng-container>
              </glxy-form-row>
              @if (showAssociationModal === false) {
                <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
                  <ng-container [ngTemplateOutlet]="addOpportunities"></ng-container>
                </glxy-form-row>
              }
              <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
                <ng-container [ngTemplateOutlet]="addTags"></ng-container>
              </glxy-form-row>
              @if (showFileAssociations()) {
                <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
                  <ng-container [ngTemplateOutlet]="addFiles"></ng-container>
                </glxy-form-row>
              }
              <ng-container [ngTemplateOutlet]="addFollowUpTask"></ng-container>
            </ng-container>
          </crm-activity-logger-note>
        }
        <!-- Email -->
        @case ('Email') {
          <crm-activity-logger-email
            class="activity-content"
            [activity]="activity$ | async"
            [mobile]="layout.mobile"
            [(description)]="sharedDescription"
          >
            <ng-container *ngTemplateOutlet="activitySelector" crmLoggerContent="after-description"></ng-container>
            <ng-container crmLoggerContent="fields">
              @if (showAssociationModal === false) {
                <ng-container *ngTemplateOutlet="associationFormRow"></ng-container>
              }
              @if (showAssociationModal) {
                <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
                  <ng-container *ngTemplateOutlet="associationFormModal"></ng-container>
                </glxy-form-row>
              }
              <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
                <ng-container [ngTemplateOutlet]="addTeamMembers"></ng-container>
              </glxy-form-row>
              @if (showAssociationModal === false) {
                <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
                  <ng-container [ngTemplateOutlet]="addOpportunities"></ng-container>
                </glxy-form-row>
              }
              <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
                <ng-container [ngTemplateOutlet]="addTags"></ng-container>
              </glxy-form-row>
              @if (showFileAssociations()) {
                <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
                  <ng-container [ngTemplateOutlet]="addFiles"></ng-container>
                </glxy-form-row>
              }
              <ng-container [ngTemplateOutlet]="addFollowUpTask"></ng-container>
            </ng-container>
          </crm-activity-logger-email>
        }
        <!-- Call -->
        @case ('Call') {
          <crm-activity-logger-call
            class="activity-content"
            [activity]="activity$ | async"
            [mobile]="layout.mobile"
            [(description)]="sharedDescription"
          >
            <ng-container *ngTemplateOutlet="activitySelector" crmLoggerContent="after-description"></ng-container>
            <ng-container crmLoggerContent="fields">
              @if (showAssociationModal === false) {
                <ng-container *ngTemplateOutlet="associationFormRow"></ng-container>
              }
              @if (showAssociationModal) {
                <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
                  <ng-container *ngTemplateOutlet="associationFormModal"></ng-container>
                </glxy-form-row>
              }
              <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
                <ng-container [ngTemplateOutlet]="addTeamMembers"></ng-container>
              </glxy-form-row>
              @if (showAssociationModal === false) {
                <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
                  <ng-container [ngTemplateOutlet]="addOpportunities"></ng-container>
                </glxy-form-row>
              }
              <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
                <ng-container [ngTemplateOutlet]="addTags"></ng-container>
              </glxy-form-row>
              @if (showFileAssociations()) {
                <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
                  <ng-container [ngTemplateOutlet]="addFiles"></ng-container>
                </glxy-form-row>
              }
              <ng-container [ngTemplateOutlet]="addFollowUpTask"></ng-container>
            </ng-container>
          </crm-activity-logger-call>
        }
        <!-- Meeting -->
        @case ('Meeting') {
          <crm-activity-logger-meeting
            class="activity-content"
            [activity]="activity$ | async"
            [mobile]="layout.mobile"
            [(description)]="sharedDescription"
          >
            <ng-container *ngTemplateOutlet="activitySelector" crmLoggerContent="after-description"></ng-container>
            <ng-container crmLoggerContent="fields">
              @if (showAssociationModal === false) {
                <ng-container *ngTemplateOutlet="associationFormRow"></ng-container>
              }
              @if (showAssociationModal) {
                <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
                  <ng-container *ngTemplateOutlet="associationFormModal"></ng-container>
                </glxy-form-row>
              }
              <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
                <ng-container [ngTemplateOutlet]="addTeamMembers"></ng-container>
              </glxy-form-row>
              @if (showAssociationModal === false) {
                <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
                  <ng-container [ngTemplateOutlet]="addOpportunities"></ng-container>
                </glxy-form-row>
              }
              <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
                <ng-container [ngTemplateOutlet]="addTags"></ng-container>
              </glxy-form-row>
              @if (showFileAssociations()) {
                <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
                  <ng-container [ngTemplateOutlet]="addFiles"></ng-container>
                </glxy-form-row>
              }
              <ng-container [ngTemplateOutlet]="addFollowUpTask"></ng-container>
            </ng-container>
          </crm-activity-logger-meeting>
        }
        <!-- Task -->
        @case ('Task') {
          <crm-activity-logger-task
            class="activity-content"
            [activity]="activity$ | async"
            [activityOwner]="activityOwner"
            [mobile]="layout.mobile"
            [user]="user$ | async"
            [(description)]="sharedDescription"
            [(associations)]="teamAssociations"
          >
            <ng-container *ngTemplateOutlet="activitySelector" crmLoggerContent="after-description"></ng-container>
            <ng-container crmLoggerContent="fields">
              @if (showAssociationModal === false) {
                <ng-container *ngTemplateOutlet="associationFormRow"></ng-container>
              }
              @if (showAssociationModal) {
                <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
                  <ng-container *ngTemplateOutlet="associationFormModal"></ng-container>
                </glxy-form-row>
              }
              @if (showAssociationModal === false) {
                <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
                  <ng-container [ngTemplateOutlet]="addOpportunities"></ng-container>
                </glxy-form-row>
              }
              <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
                <ng-container [ngTemplateOutlet]="addTags"></ng-container>
              </glxy-form-row>
              <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
                <ng-container [ngTemplateOutlet]="addFiles"></ng-container>
              </glxy-form-row>
            </ng-container>
          </crm-activity-logger-task>
        }
        <!-- Communication -->
        @case ('Communication') {
          <crm-activity-logger-communication
            class="activity-content"
            [activity]="activity$ | async"
            [mobile]="layout.mobile"
            [communicationType]="communicationSubTypeSelected!"
            [(description)]="sharedDescription"
          >
            <ng-container *ngTemplateOutlet="activitySelector" crmLoggerContent="after-description"></ng-container>
            <ng-container crmLoggerContent="fields">
              @if (showAssociationModal === false) {
                <ng-container *ngTemplateOutlet="associationFormRow"></ng-container>
              }
              @if (showAssociationModal) {
                <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
                  <ng-container *ngTemplateOutlet="associationFormModal"></ng-container>
                </glxy-form-row>
              }
              <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
                <ng-container [ngTemplateOutlet]="addTeamMembers"></ng-container>
              </glxy-form-row>
              @if (showAssociationModal === false) {
                <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
                  <ng-container [ngTemplateOutlet]="addOpportunities"></ng-container>
                </glxy-form-row>
              }
              <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
                <ng-container [ngTemplateOutlet]="addTags"></ng-container>
              </glxy-form-row>
              @if (showFileAssociations()) {
                <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
                  <ng-container [ngTemplateOutlet]="addFiles"></ng-container>
                </glxy-form-row>
              }
              <ng-container [ngTemplateOutlet]="addFollowUpTask"></ng-container>
            </ng-container>
          </crm-activity-logger-communication>
        }
        <!-- Default state (collapsed) -->
        @default {
          <form class="activity-content">
            <div class="content-container">
              <glxy-form-row>
                <glxy-form-field bottomSpacing="small" [showLabel]="false">
                  <textarea
                    matInput
                    placeholder="{{ 'ACTIVITY_LOGGER.NOTE_PLACEHOLDER' | translate }}"
                    [rows]="1"
                    (focus)="handleDefaultStateFocus()"
                  ></textarea>
                </glxy-form-field>
              </glxy-form-row>
            </div>
            <ng-container
              [ngTemplateOutlet]="activitySelector"
              [ngTemplateOutletContext]="{ noMargins: true }"
            ></ng-container>
          </form>
        }
      }
    </mat-card-content>
    @if (activityTypeSelected) {
      <ng-container *ngTemplateOutlet="formButtons"></ng-container>
    }
  </mat-card>
  <ng-template #avatar>
    <div class="avatar-container" [class.mobile]="layout.mobile" [class.editing]="layout.editing">
      @if (user$ | async; as user) {
        <glxy-avatar
          matCardAvatar
          [name]="user.fullName || ''"
          [width]="AVATAR_WIDTH"
          [src]="user.profileImageUrl || ''"
        ></glxy-avatar>
      } @else {
        <crm-unknown-user-avatar [width]="AVATAR_WIDTH"></crm-unknown-user-avatar>
      }
    </div>
  </ng-template>
  <ng-template #activitySelector let-noMargins="noMargins">
    @if (!layout.editing) {
      <div class="activity-type-selector" [class.no-margins]="noMargins">
        <div class="inline-container">
          <crm-chip-list
            #activityTypeSelector
            [attr.aria-label]="'ACTIVITY_LOGGER.ACTIVITY_TYPE_SELECTOR_ARIA_LABEL' | translate"
            [hideLabelWhenSelected]="layout.mobile"
            [items]="SELECTABLE_ACTIVITY_TYPES"
            [selected]="activityTypeSelected"
            (selectedChange)="onActivityTypeChanged($event)"
            [size]="layout.mobile ? 'large' : 'default'"
          ></crm-chip-list>
          <!-- dropdown communication subtypes -->
          <button mat-stroked-button [matMenuTriggerFor]="communicationMenu" class="button-with-margin" type="button">
            {{ getTranslatedCommunicationType() | translate }}
            <mat-icon class="dropdown-arrow" iconPositionEnd>arrow_drop_down</mat-icon>
          </button>
          <mat-menu #communicationMenu="matMenu">
            @for (communicationType of SELECTABLE_COMMUNICATION_TYPES; track communicationType) {
              <button mat-menu-item (click)="onCommunicationTypeChanged('Communication', communicationType.value)">
                {{ communicationType.label | translate }}
              </button>
            }
          </mat-menu>
        </div>
      </div>
    }
  </ng-template>
  <ng-template #associationFormRow>
    @if (!hideCrmObjectAssociations) {
      <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
        <glxy-form-field
          [prefixIcon]="'person'"
          bottomSpacing="small"
          class="col detail-form-field"
          [class.mobile]="layout.mobile"
        >
          <crm-object-association-form-field
            [objectType]="'Contact'"
            [(associationsList)]="contactAssociations"
            insideInputWrapper
          ></crm-object-association-form-field>
        </glxy-form-field>
        <glxy-form-field
          prefixIcon="domain"
          bottomSpacing="small"
          class="col detail-form-field"
          [class.mobile]="layout.mobile"
        >
          <crm-object-association-form-field
            [objectType]="'Company'"
            [(associationsList)]="companyAssociations"
            insideInputWrapper
          ></crm-object-association-form-field>
        </glxy-form-field>
      </glxy-form-row>
    }
  </ng-template>
  <ng-template #formButtons>
    <mat-card-actions [align]="'start'" class="activity-form-actions" [class.editing]="layout.editing">
      @if (!enableNewActivityFeed()) {
        <div
          class="avatar-container"
          [class.mobile]="layout.mobile"
          [class.editing]="layout.editing"
          [style.width.px]="AVATAR_WIDTH"
        ></div>
      }
      <button
        mat-flat-button
        color="primary"
        type="button"
        (click)="upsertActivity()"
        [disabled]="upsertActivityButtonLoading$ | async"
      >
        <glxy-button-loading-indicator [isLoading]="(upsertActivityButtonLoading$ | async) === true">
          @if (layout.editing) {
            {{ 'ACTIVITY_LOGGER.SAVE' | translate }}
          } @else {
            @if (activityTypeSelected === 'Task') {
              {{ 'ACTIVITY_LOGGER.CREATE_TASK' | translate }}
            } @else {
              {{ 'ACTIVITY_LOGGER.LOG_ACTIVITY' | translate }}
            }
          }
        </glxy-button-loading-indicator>
      </button>
      <button mat-stroked-button (click)="handleCancelClicked()" type="button">
        {{ 'ACTIVITY_LOGGER.CANCEL' | translate }}
      </button>
    </mat-card-actions>
  </ng-template>
  <ng-template #addTeamMembers>
    @if (showTeamMemberInput) {
      <glxy-form-field
        prefixIcon="group"
        bottomSpacing="small"
        class="detail-form-field"
        [class.mobile]="layout.mobile"
      >
        <crm-team-association-form-field
          insideInputWrapper
          class="col"
          [(associations)]="teamAssociations"
          [fixedId]="activityOwnerId$ | async"
          [mobile]="layout.mobile"
          [placeholder]="'ACTIVITY_LOGGER.ADD_TEAM_MEMBER_ASSOCIATION' | translate"
        ></crm-team-association-form-field>
      </glxy-form-field>
    }
  </ng-template>
  <ng-template #addOpportunities>
    @if (hasOpportunityType$ | async) {
      <glxy-form-field
        prefixIcon="monetization_on"
        bottomSpacing="small"
        class="detail-form-field"
        [class.mobile]="layout.mobile"
      >
        <crm-sales-opportunity-association-form-field
          insideInputWrapper
          class="col"
          [accountGroupId]="primaryAccountGroupId$ | async"
          [(associations)]="opportunityAssociations"
          [mobile]="layout.mobile"
          [placeholder]="'ACTIVITY_LOGGER.ADD_OPPORTUNITY_ASSOCIATION' | translate"
        ></crm-sales-opportunity-association-form-field>
      </glxy-form-field>
    }
  </ng-template>
  <ng-template #addTags>
    <glxy-form-field
      prefixIcon="local_offer"
      bottomSpacing="small"
      class="detail-form-field"
      [class.mobile]="layout.mobile"
    >
      <crm-activity-logger-tags
        insideInputWrapper
        class="col"
        [tags]="(tags$ | async) || []"
        [mobile]="layout.mobile"
        (tagsChanged)="updateTags($event)"
      ></crm-activity-logger-tags>
    </glxy-form-field>
  </ng-template>
  <ng-template #addFiles>
    <glxy-form-field
      prefixIcon="attach_file"
      bottomSpacing="small"
      class="detail-form-field"
      [class.mobile]="layout.mobile"
    >
      <div class="files-container col" insideInputWrapper>
        @if (associatedFiles().length > 0) {
          <div class="files-list">
            @for (file of associatedFiles(); track trackByFileId($index, file)) {
              <div class="file-item">
                <div class="file-content">
                  <mat-icon class="file-icon">{{ getFileTypeIcon(file.contentType) }}</mat-icon>
                  <span class="file-name" (click)="viewFile(file)" [matTooltip]="file.fileName">
                    {{ file.fileName }}
                  </span>
                  <span class="file-details">
                    {{ file.uploadDate | date: 'MMM d, y' }}
                    @if (file.fileSize) {
                      <span class="file-size"> • {{ getFileSizeDisplay(file.fileSize) }} </span>
                    }
                  </span>
                </div>
                <div class="file-actions">
                  <button
                    mat-icon-button
                    (click)="downloadFile(file)"
                    [matTooltip]="'ASSOCIATIONS.FILES.DOWNLOAD' | translate"
                    class="download-btn"
                  >
                    <mat-icon>download</mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    (click)="removeFileAssociation(file)"
                    [matTooltip]="'ASSOCIATIONS.FILES.REMOVE' | translate"
                    class="remove-btn"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </div>
            }
          </div>
        }
        <button mat-button class="add-files-btn" color="primary" (click)="toggleFileUploader()" type="button">
          + {{ 'ASSOCIATIONS.FILES.ADD_FILE' | translate }}
        </button>
      </div>
    </glxy-form-field>
  </ng-template>
  <ng-template #addFollowUpTask>
    @if (!layout.editing) {
      <crm-activity-logger-follow-up-task
        (expandedChanged)="followUpExpandedChanged($event)"
      ></crm-activity-logger-follow-up-task>
    }
  </ng-template>
  <!-- File uploader modal -->
  @if (showFileUploader) {
    <div class="file-uploader-modal" (click)="showFileUploader = false">
      <div class="modal-content" (click)="$event.stopPropagation()">
        <div class="modal-header">
          <h3>{{ 'ASSOCIATIONS.FILES.ADD_FILE' | translate }}</h3>
          <button mat-icon-button (click)="showFileUploader = false" class="close-btn">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="modal-body">
          <glxy-uploader
            [uploadHandler]="signedUrlUploadHandler"
            (fileUploaded)="onFileUploaded($event)"
            (fileUploadErrored)="onFileUploadError($event)"
            (filesChanged)="onFilesChanged($event)"
            [maxFiles]="5"
            accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
            [accessTypeOptions]="fileAccessTypeOptions"
            [(accessType)]="selectedAccessType"
            class="file-uploader"
          ></glxy-uploader>
        </div>
      </div>
    </div>
  }
  <ng-template #associationFormModal>
    @if (!hideCrmObjectAssociations) {
      <glxy-form-field prefixIcon="link" bottomSpacing="small" class="detail-form-field" [class.mobile]="layout.mobile">
        <crm-multi-object-association-form-field
          [associationFormFields]="objectAssociations()"
          [accountGroupId]="primaryAccountGroupId$ | async"
          [isMobile]="!!layout.mobile"
          [availableObjectTypes]="(availableObjectTypes$ | async) || []"
          (associationFormFieldsOutput)="handleObjectAssociationsUpdate($event)"
          insideInputWrapper
        ></crm-multi-object-association-form-field>
      </glxy-form-field>
    }
  </ng-template>
}
